import * as React from 'react';

import CreativeAssets56 from './CreativeAssets56';

export const creativeAssets56 = () => <CreativeAssets56 />;

export default {
    title: 'Illustration|CreativeAssets56',
    component: CreativeAssets56,
    parameters: {
        notes: "`import CreativeAssets56 from 'box-ui-elements/es/illustration/CreativeAssets56';`",
    },
};
